module.exports = __webpack_public_path__ + "static/media/DoctorManhattan.2a4e8574.jpg";